import { createSelector } from "reselect";

import getFloorId from "../floor_getters/get_floor_id";
import { PlannedBuildingElementArg } from "../../../models/domain/planned_building_element";

import type { ReduxStore } from "../../reducers/root_reducer";

const empty: { [globalId: string]: PlannedBuildingElementArg } = {};

const getElementDetailsByGlobalId = createSelector([
  (state: ReduxStore) => state.domain.elementDetails,
  getFloorId
], (elementDetails, floorId) => elementDetails?.byFirebaseFloorId?.[floorId]?.byGlobalId || empty);

export default getElementDetailsByGlobalId;
